import HiggsPromise from '../utils/higgsPromise';
import { HttpMethod } from '../constants/enum';

/* ---------------- 个人收藏 ---------------- */
// 添加收藏
export function addCollection(data) {
    return HiggsPromise({
        url: '/user/collect/add',
        type: HttpMethod.POST,
        data: data
    });
}

// 取消收藏
export function cancelCollection(data) {
    return HiggsPromise({
        url: '/user/collect/cancel',
        type: HttpMethod.POST,
        data: data
    });
}



// WEBPACK FOOTER //
// ./src/services/personalCollect.js